<app-helpful-links [channelMapDataHelfulLink]="helpfulLinksList"></app-helpful-links>

<div class="footer-container text-sm">
  <nav class="footer mb-0" id="theFooter">
    <div class="footer-margin d-flex flex-column flex-sm-row">
      <div class="col-sm-6 pl-0 pr-0">{{ "countryLang" | translate }} : <span title="en-us">{{ "language" | translate }}</span>
        <div class="text-nowrap footer-link">© <a [href]="countryData?.websiteLink" target="_blank" rel="noopener noreferrer" aria-label="Dun & Bradstreet,
          Inc., opens in a new window">Dun &amp; Bradstreet,
            Inc.</a>
          2000-{{currentYear}}. {{"allRights" | translate}} </div>
      </div>
      <div class="col-sm-6 pl-0 pr-0">
        <div class="footer-link d-flex justify-content-lg-end justify-content-md-end justify-content-sm-start">
          <a class="text-nowrap" [href]="countryData?.footerDetails?.privacyLink" target="_blank" rel="noopener noreferrer" aria-label="Privacy
          Policy, opens in a new window">{{"privacy-policy" | translate}} |</a>
          <a class="text-nowrap footer-terms" [href]="countryData?.footerDetails?.termsLink"
            target="_blank" rel="noopener noreferrer" aria-label="Terms of Use, opens in a new window">{{"terms" | translate}}</a>
        </div>
      </div>
    </div>
  </nav>
</div>